import React from 'react';
import {connect} from 'react-redux';
import TeamLogo from 'components/molecules/team-logo';
import {LineupPlayerFinalTableRow} from 'components/organisms/lineup/components/desktop/lineup-players/component/lineup-player-final-table-row';
import {LineupPlayerFinalTableHead} from 'components/organisms/lineup/components/desktop/lineup-players/component/lineup-player-final-table-head';
import {LineupPlayersSketch} from 'components/organisms/lineup/components/lineup-players/sports/lol/classic';

class LineupPlayersComponent extends LineupPlayersSketch {
    render() {
        const {lineups, lineupId} = this.props;
        const lineup = lineups.getLineup(lineupId);

        const rows = [];
        lineup.players.map((player) => {
            const salary = player.getPropValueOfLineupRole('salary');
            const points = player.lineupPoints;
            const className = this.getStackClassNameByPlayer(player);
            const rowClassName = this.getRowClassName(player);

            rows.push(
                <tr key={player.playerId} className={rowClassName}>
                    <td>{player.positionInLineup}</td>
                    <td>
                        <strong className={`player-name ${className}`}>{player.name}</strong>
                    </td>
                    <td className="td-team">
                        <TeamLogo teamName={player.team} />
                    </td>
                    <td>{salary}</td>
                    <td>{points}</td>
                    <LineupPlayerFinalTableRow points={player.fantasyPoints} />
                    <td className="td-exchange">{this.getExchangePlayerButton({player, lineup})}</td>
                </tr>,
            );
        });

        return (
            <table className="table">
                <tbody>
                    <tr>
                        <th className="td-pos">Pos</th>
                        <th>Name</th>
                        <th className="td-team">Team</th>
                        <th className="td-salary">Salary</th>
                        <th className="td-fpts">Fpts</th>
                        <LineupPlayerFinalTableHead />
                        <th className="td-exchange" />
                    </tr>
                    {rows}
                </tbody>
            </table>
        );
    }
}

function mapStatesToProps(state) {
    const {
        sportConfig,
        playersData: {games},
        randomTeamStacking,
        lineupsData,
        filterLineupsByPlayer,
    } = state;

    return {
        sportConfig,
        games,
        lineups: lineupsData.lineups,
        rawLineups: lineupsData.rawLineups,
        stacking: randomTeamStacking,
        filterLineupsByPlayer,
    };
}

const LineupPlayers = connect(mapStatesToProps)(LineupPlayersComponent);

export {LineupPlayers};
